const nodeTypeMap = {
    BannerNodeModel: "BANNER",
    BeginNodeModel: "MODULE_START_POINT",
    CustomNodeModel: "CUSTOM",
    DataAccessCompletionNodeModel: "DATA_ACCESS_COMPLETION",
    DataNodeModel: "DATA_ACCESS",
    DialogManagerNodeModel: "DIALOG_MANAGER",
    DtmfNodeModel: "DTMF_MENU",
    ExitNodeModel: "MODULE_END_POINT",
    FlushPromptsNodeModel: "FLUSH_PROMPTS",
    InputNodeModel: "INPUT",
    IntentDataModel: "INTENT",
    LoopEscalationNodeModel: "LOOP_ESCALATION",
    ModuleNodeModel: "MODULE",
    ModuleReferenceNodeModel: "VARIABLE_MODULE_REFERENCE",
    PlaySavedPromptNodeModel: "PLAY_SAVE_PROMPT",
    PromptNodeModel: "PROMPT",
    PromptReferenceNodeModel: "PROMPT_REFERENCE",
    ReportBillingNodeModel: "REPORT_BILLING",
    ReportNodeModel: "REPORTING",
    RichTextNodeModel: "RICH_TEXT",
    SavePromptNodeModel: "SAVE_PROMPT",
    SessionCompletionNodeModel: "SIMULTANEOUS_SESSION_COMPLETION",
    SessionNodeModel: "START_SIMULTANEOUS_SESSION",
    TabNodeModel: "TABULAR",
    TaskOrchestrationNodeModel: "TASK_ORCHESTRATION",
    VariableDataModel: "VARIABLE",
    VXMLRenderNodeModel: "VXML_RENDER",
    WithFillerNodeModel: "WITH_FILLER"
};

module.exports = nodeTypeMap;